import { useCallback, useMemo } from 'react'
import useProjectId from '../../../../customHooks/useProjectId'
import { useUser } from '../../../../fetchData/queries/useUser'
import { MenuItemProps } from '../MenuButton'

export const useReportsMenu = () => {
  const projectId = useProjectId()

  const { data } = useUser()
  const scopes = data?.scopes

  const navigateToReport = useCallback((reportRoute: string) => {
    const newTabUrl: string = `${window.location.origin}/rapport/${reportRoute}`
    window.open(newTabUrl, '_blank', 'noreferrer')
  }, [])

  const menuItems = useMemo(() => {
    const items: MenuItemProps[] = []

    if (scopes?.['report_read']) {
      items.push(
        {
          key: 'resCalc',
          text: 'Resultatavräkning',
          onClick: () => navigateToReport(`resultatavrakning/${projectId}`),
        },
        {
          key: 'finalAccount',
          text: 'Slutredovisning',
          onClick: () => navigateToReport(`slutredovisning/${projectId}`),
        },
        {
          key: 'profitOnContract',
          text: 'Entreprenadvinst',
          onClick: () => navigateToReport(`entreprenadVinst/${projectId}`),
        },
        {
          key: 'projektprognos',
          text: 'Prognosuppföljning',
          onClick: () => navigateToReport(`projektprognos/${projectId}`),
        }
      )
    }

    if (scopes?.['accounting_read']) {
      items.push(
        {
          key: 'resCalcProj',
          text: 'Resultatavräknade projekt',
          onClick: () => navigateToReport('resultatavraknadeProjekt'),
        },
        {
          key: 'resCalcForecast',
          text: 'Prognos resultatavräkning',
          onClick: () => navigateToReport('prognosResultatavrakning'),
        }
      )
    }

    return items
  }, [navigateToReport, projectId, scopes])

  return menuItems
}
